import { Province } from './provinces';

export const provincesCanada: Province[] = [
    {
        code: 'AB',
        name: 'Alberta',
        country: 'CA',
        localization: {
            fr: 'l\'Alberta'
        }
    },
    {
        code: 'BC',
        name: 'British Columbia',
        country: 'CA',
        localization: {
            fr: 'la Colombie-Britannique'
        }
    },
    {
        code: 'MB',
        name: 'Manitoba',
        country: 'CA',
        localization: {
            fr: 'le Manitoba'
        }
    },
    {
        code: 'NB',
        name: 'New Brunswick',
        country: 'CA',
        localization: {
            fr: 'le Nouveau-Brunswick'
        }
    },
    {
        code: 'NL',
        name: 'Newfoundland and Labrador',
        country: 'CA',
        localization: {
            fr: 'la Terre-Neuve-et-Labrador'
        }
    },
    {
        code: 'NS',
        name: 'Nova Scotia',
        country: 'CA',
        localization: {
            fr: 'la Nouvelle-Écosse'
        }
    },
    {
        code: 'NT',
        name: 'Northwest Territories',
        country: 'CA',
        localization: {
            fr: 'les Territoires du Nord-Ouest'
        }
    },
    {
        code: 'NU',
        name: 'Nunavut',
        country: 'CA',
        localization: {
            fr: 'le Nunavut'
        }
    },
    {
        code: 'ON',
        name: 'Ontario',
        country: 'CA',
        localization: {
            fr: 'l\'Ontario'
        }
    },
    {
        code: 'PE',
        name: 'Prince Edward Island',
        country: 'CA',
        localization: {
            fr: 'l\'île-du-Prince-Édouard'
        }
    },
    {
        code: 'QC',
        name: 'Québec',
        country: 'CA',
        localization: {
            fr: 'le Québec'
        }
    },
    {
        code: 'SK',
        name: 'Saskatchewan',
        country: 'CA',
        localization: {
            fr: 'la Saskatchewan'
        }
    },
    {
        code: 'YT',
        name: 'Yukon',
        country: 'CA',
        localization: {
            fr: 'le territoire du Yukon'
        }
    }
];
